export const Configurations = {
  dev: {
    name: "Taxio Desarrollo",
    races: {
      pricePerKm: 2000,
      predefinedFrom: true,
    },
    api: "http://localhost:8080/api",
    // api: "https://api.taxiosf.cosmesoft.com.py/api",
    maps: {
      key: "AIzaSyAcZVbIDdV7dM8nAiIPsCXnjUY51gXZPJI",
      startingLocation: {
        lat: -25.301878,
        lng: -57.5844456,
        zoom: 13,
      },
      region: "Paraguay",
    },
    debug: false,
  },
  prodPy: {
    name: "Taxio - Santa Fe",
    races: { pricePerKm: 2000, predefinedFrom: true },
    api: "https://api.taxiosf.cosmesoft.com.py/api",
    maps: {
      key: "AIzaSyAcZVbIDdV7dM8nAiIPsCXnjUY51gXZPJI",
      startingLocation: { lat: -25.301878, lng: -57.5844456, zoom: 13 },
    },
    region: "Paraguay",
    debug: false,
  },
  prodSantafe: {
    name: "Taxio Paraguay",
    races: { pricePerKm: 2000, predefinedFrom: true },
    api: "https://taxiosantafe.cosmesoft.com.py/api",
    maps: {
      key: "AIzaSyAcZVbIDdV7dM8nAiIPsCXnjUY51gXZPJI",
      startingLocation: { lat: -25.301878, lng: -57.5844456, zoom: 13 },
    },
    region: "Paraguay",
  },
  prod: {
    name: "Taxio Bolivia",
    races: {
      pricePerKm: 3.45,
    },
    api: "https://taxio.devel.cosmesoft.com.py/api",
    maps: {
      key: "AIzaSyAcZVbIDdV7dM8nAiIPsCXnjUY51gXZPJI",
      startingLocation: {
        lat: -17.775608,
        lng: -63.1812027,
        zoom: 13,
      },
      region: "Bolivia",
    },
  },
};

export type ConfigData = typeof Configurations.dev;

export const active: string = 'prodPy';

export function getConfig(configName: string): ConfigData {
  if (Configurations[configName]) {
    return Configurations[configName];
  } else {
    const key = Object.keys(Configurations).find((configKey) => {
      if (Configurations[configKey].name === configName) {
        return true;
      }
      return false;
    });
    if (key) {
      console.log("new config", key);
      return Configurations[key];
    }
  }
  throw new Error(`Configuration with name ${configName} not found`);
}



// WEBPACK FOOTER //
// ./src/config.ts